import { render, staticRenderFns } from "./TableDraggable.vue?vue&type=template&id=4c17f4d0&scoped=true&"
import script from "./TableDraggable.vue?vue&type=script&lang=js&"
export * from "./TableDraggable.vue?vue&type=script&lang=js&"
import style0 from "./TableDraggable.vue?vue&type=style&index=0&id=4c17f4d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c17f4d0",
  null
  
)

export default component.exports